import React from 'react'
import Products from '../components/Products'
import Categories from '../components/Categories'
import SlideShow from '../components/SlideShow'

function Main() {
    return (
        <div >
            <SlideShow />
            <Categories />
            <Products />
        </div >
    );
}

export default Main;